<div class="container">
  <div class="text-center mt-2">
    <strong style="font-size: 1.5rem; color: #8e0e00"
      >User Summary Report</strong
    >
  </div>

  <div class="d-flex align-items-end gap-3 mt-3">
    <!-- Filters (Dropdowns) -->
    <div class="d-flex gap-3 flex-grow-1">
      <div class="col-auto">
        <label for="userType" class="form-label mb-0">Type of user</label>
        <select
          id="userType"
          class="form-select"
          (change)="onUserTypeChange($event)"
        >
          <option value="">All</option>
          <option *ngFor="let type of userTypeList" [value]="type.id">
            {{ type.userType }}
          </option>
        </select>
      </div>

      <div class="col-auto">
        <label for="city" class="form-label mb-0">City</label>
        <select id="city" class="form-select" (change)="onCityChange($event)">
          <option value="">All Cities</option>
          <option *ngFor="let city of cityList" [value]="city.id">
            {{ city.cityName }}
          </option>
        </select>
      </div>

      <div class="col-auto">
        <label for="zone" class="form-label mb-0">Zone</label>
        <select
          id="zone"
          class="form-select"
          [(ngModel)]="selectedZone"
          (change)="onZoneChange($event)"
        >
          <option value="">All Zones</option>
          <option *ngFor="let zone of zoneList" [value]="zone.zoneId">
            {{ zone.zoneName }}
          </option>
        </select>
      </div>
    </div>

    <!-- Export Button -->
    <!-- <button class="btn btn-outline-secondary" type="button" ngbTooltip="Export" (click)="exportToExcel()">
      <i class="bi bi-box-arrow-up me-2"></i> Export
    </button> -->

    <div class="d-flex align-items-center">
      <button
        class="btn btn-outline-secondary"
        type="button"
        ngbTooltip="Export"
        (click)="exportToExcel()"
      >
        <span><i class="bi bi-box-arrow-up me-2"></i></span>
        Export
      </button>
      <button
        class="btn btn-outline-secondary ms-2"
        type="button"
        ngbTooltip="Print"
        (click)="exportToPDF()"
      >
        <span><i class="bi bi-printer me-2"></i></span>
        Print
      </button>
    </div>
  </div>

  <!-- User List and Details -->
  <div class="row mt-3">
    <!-- User List Card (30% width and scrollable) -->
    <div class="col-md-3">
      <div class="card" style="height: 110vh">
        <div class="card-body">
          <strong style="color: #8e0e00" class="fs-5">User List</strong>
          <!-- Search Input Below User List -->
          <div class="mt-3">
            <input
              id="search"
              type="text"
              class="form-control"
              placeholder="Search"
              [(ngModel)]="searchText"
              (ngModelChange)="filterUsers()"
            />
          </div>
          <div class="user-list-scroll mt-2">
            <ul class="list-group mt-2 user-list">
              <!-- Display filtered users -->
              <li
                *ngFor="let user of filteredUserList"
                class="list-group-item d-flex justify-content-start align-items-center"
                (click)="getUsersById(user)"
                [class.active]="selectedUser?.id === user.id"
              >
                <div class="d-flex align-items-center">
                  <div>
                    <!-- User Name -->
                    <div class="d-flex align-items-center">
                      <i class="bi bi-person-fill me-2"></i>
                      <strong>{{
                        user.userType === "1" ? user.userName : user.companyName
                      }}</strong>
                    </div>
                    <!-- User Phone Number -->
                    <div class="d-flex align-items-center">
                      <i class="bi bi-telephone-fill me-2"></i>
                      {{ user.phoneNo }}
                    </div>
                    <!-- User Type -->
                    <div class="d-flex align-items-center">
                      <i class="bi bi-person-bounding-box me-2"></i>
                      <small>{{ getType(user.userType) }}</small>
                    </div>
                  </div>
                </div>
              </li>
              <h3 class="text-center" *ngIf="filteredUserList?.length === 0">
                No Data Found
              </h3>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- User Details (Table) -->
    <div class="col-md-9">
      <div *ngIf="!userById" class="text-center mt-4 text-muted mt-5 message">
        <img
          src="assets/Images/rb_2148638193.png"
          alt="Select User Icon"
          class="select-user-icon"
        />

        <!-- Message with Icon -->
        <div class="d-flex align-items-center justify-content-center">
          <i
            class="fas fa-arrow-alt-circle-left ms-2 icon-message"
            style="font-size: 3rem"
          ></i>
          <p class="message-text">
            Select any user from the user list to view more details
          </p>
        </div>
      </div>

      <!-- User Details Table (only shows when a user is selected) -->
      <div *ngIf="userById" class="card shadow-lg p-3">
        <div class="d-flex align-items-center">
          <h5 style="color: #8e0e00">
            {{ userType === "1" ? userName : companyName }}'s Records
          </h5>
          <!-- From Date -->
          <div class="d-flex ms-auto gap-3">
            <div class="d-flex align-items-center gap-2">
              <label for="fromDate" class="form-label text-nowrap"
                >From Date:</label
              >
              <input
                type="date"
                id="fromDate"
                [(ngModel)]="ngFromDate"
                (change)="onFromDateChange($event)"
                class="form-control"
              />
            </div>

            <!-- To Date -->
            <div class="d-flex align-items-center gap-2">
              <label for="toDate" class="form-label text-nowrap"
                >To Date:</label
              >
              <input
                type="date"
                id="toDate"
                (change)="onToDateChange($event)"
                [(ngModel)]="ngToDate"
                class="form-control"
                [disabled]="!isToDateShow"
              />
            </div>
          </div>
        </div>
        <div class="scrollable-x">
          <table class="table table-bordered table-striped mt-3">
            <thead>
              <tr>
                <th>Year</th>
                <th>Month</th>
                <th>Total Orders</th>
                <th>No Of Containers Booked (NOS)</th>
                <th>No Of Trips Achieved</th>
                <th>Total Quantity Disposed (TONS)</th>
                <th *ngIf="userType === '1' || userType === '2'">
                  SAR Received From Requestor
                </th>
                <th *ngIf="userType === '1' || userType === '2'">
                  SAR Refunded to Requestor
                </th>
                <th *ngIf="userType === '3'">SAR Allocated Dumpster</th>
                <th *ngIf="userType === '4'">SAR Allocated Dump Yard</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let record of pagedData">
                <td>{{ record.year }}</td>
                <td>{{ record.month }}</td>
                <td>{{ record.totalorders }}</td>
                <td>{{ record.noOfContainerBooked }}</td>
                <td>{{ record.noOfTripAchieved }}</td>
                <td>{{ record.totalTonDisposed }}</td>
                <td *ngIf="userType === '1' || userType === '2'">
                  {{ record.sarReceivedFromRequestor }}
                </td>
                <td *ngIf="userType === '1' || userType === '2'">
                  {{ record.sarReFundedToRequestor }}
                </td>
                <td *ngIf="userType === '3'">
                  {{ record.sarAllocatedDumpster }}
                </td>
                <td *ngIf="userType === '4'">
                  {{ record.sarAllocatedDumpyard }}
                </td>
              </tr>
              <tr *ngIf="userById.records?.length === 0">
                <td colspan="11" class="text-center text-muted">
                  No Records Found
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="2" class="text-end"><strong>Total:</strong></td>
                <td>{{ getColumnTotal("totalOrders") }}</td>
                <td>{{ getColumnTotal("noOfContainerBooked") }}</td>
                <td>{{ getColumnTotal("noOfTripAchieved") }}</td>
                <td>{{ getColumnTotal("totalTonDisposed") }}</td>
                <td *ngIf="userType === '1' || userType === '2'">
                  {{ getColumnTotal("sarReceivedFromRequestor") }}
                </td>
                <td *ngIf="userType === '1' || userType === '2'">
                  {{ getColumnTotal("sarReFundedToRequestor") }}
                </td>
                <td *ngIf="userType === '3'">
                  {{ getColumnTotal("sarAllocatedDumpster") }}
                </td>
                <td *ngIf="userType === '4'">
                  {{ getColumnTotal("sarAllocatedDumpyard") }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <!-- Pagination -->
        <div class="d-flex justify-content-between">
          <div
            *ngIf="userById?.length > itemsPerPage"
            class="mt-3 d-flex justify-content-center"
          >
            <ngb-pagination
              [(page)]="currentPage"
              [pageSize]="itemsPerPage"
              [collectionSize]="userById.length"
              (pageChange)="onPageChange($event)"
              aria-label="Pagination"
              [boundaryLinks]="true"
            ></ngb-pagination>
          </div>

          <!-- Entries Message Aligned to the End -->
          <div *ngIf="userById?.length > 0" class="text-muted mb-3 mt-4">
            <p>
              Showing
              {{ (currentPage - 1) * itemsPerPage + 1 }}
              to
              {{
                currentPage * itemsPerPage > userById?.length
                  ? userById?.length
                  : currentPage * itemsPerPage
              }}
              of {{ userById?.length }} entries
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
